export { default as AssessmentFAB } from "./AssessmentFab";
